export const COMPANY = Object.freeze({
    // 인도네시아 법인명
    name: 'PT. SAMJIN BROTHREAD INDONESIA',
    // 한국 본사 법인명
    parentName: 'SAMJINST CO.,LTD',

    // 주소
    address: 'JI. Pinang Delta Silikon 3, Lippo Cikarang Blok F16 No.9 Kel. Cicau, Cikarang Pusat-Bekasi',
    // 도시/우편번호
    cityRegion: 'Bekasi - Jawa Barat 17530',

    // 연락처
    phone: '62-21-29288466',
    phoneLabel: 'Tel : 62-21-29288466',

    // 인도네시아 대표자 성함(법인장)
    ceo: Object.freeze({
        nameKo: '김국준',
        nameEn: 'KIM GUK JUN'
    }),

    // NPWP 및 NITKU
    tax: Object.freeze({
        npwp: '72.915.045.8-413.000',
        nitku: '0729150458413000000000'
    }),

    // 인도네시아 은행 정보
    bank: Object.freeze({
        name: 'BANK WOORI SAUDARA',
        accountUSD: '200936004068',
        accountIDR: '200936004057',
        swiftCode: 'HVBKIDJA',
        accountName: 'PT. SAMJIN BROTHREAD INDONESIA'
    })
});

export default COMPANY;